import { ClipboardIcon } from "@heroicons/react/20/solid";
import { BuildingOffice2Icon } from "@/icons/solid";
import { format, formatDuration, intervalToDuration, isValid, parse } from "date-fns";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Tooltip from "@/tooltip";
import { Actions as AUTHENTICATIONACTIONS } from "../../store/actions/authenticationActions";
import { useMemo } from "react";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

function getDuration(startDate, endDate) {
	if (!endDate || !startDate) return null;

	try {
		if (typeof startDate === "string") {
			startDate = new Date(startDate);
		}
		if (typeof endDate === "string") {
			endDate = new Date(endDate);
		}
	} catch {
		return null;
	}

	const { years, months, days } = intervalToDuration({ start: startDate, end: endDate });

	if (!years && !months && !days) return "Today";

	return `${formatDuration({ months, years, days }, { delimiter: ", " })}`;
}

const ClientRow = ({ client, switchCompany, plansList }) => {
	const daysCreatedAgo = useMemo(() => {
		if (client?.createdAt) {
			return getDuration(client?.createdAt, new Date());
		} else {
			return "";
		}
	}, [client?.createdAt]);

	const createdAt = client?.createdAt ? format(new Date(client?.createdAt), "dd/MM/yyyy HH:mm:ss") : null;
	const updatedAt = client?.updatedAt ? format(new Date(client?.updatedAt), "dd/MM/yyyy HH:mm:ss") : null;
	const setupUpdatedAt = client?.setupUpdatedAt
		? format(new Date(client?.setupUpdatedAt), "dd/MM/yyyy HH:mm:ss")
		: null;

	return (
		<tr>
			<td>
				<div
					className="btn btn-xs btn-default"
					type="button"
					onClick={() => copyToClipboard(client.id)}
					style={{ marginRight: "0.5rem" }}
				>
					<ClipboardIcon
						className="h-5 w-5 text-dark-gray"
						style={{ marginTop: "3px" }}
					/>
				</div>
				<Link
					to={`/organisation/people`}
					type="button"
					onClick={(e) => {
						// e.preventDefault();
						switchCompany(client?.id, `/people`);
					}}
				>
					{client?.name}
				</Link>
			</td>
			<td>
				{client?.advisorName ? (
					<div
						className="btn btn-xs btn-default"
						type="button"
						onClick={() => copyToClipboard(client.advisor)}
						style={{ marginRight: "0.5rem" }}
					>
						<ClipboardIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</div>
				) : null}
				{client.advisor ? client?.advisorName || "Unknown Advisor" : ""}
			</td>
			<td style={{ textAlign: "center" }}>{plansList?.find((plan) => plan.id == client?.plan)?.name}</td>
			<td style={{ textAlign: "center" }}>{client?.status}</td>
			<td style={{ textAlign: "center" }}>
				<Tooltip
					content={
						<div style={{ whiteSpace: "nowrap" }}>
							<p style={{ color: "white", fontWeight: 700 }}>Stats</p>
							<ul style={{ whiteSpace: "nowrap", textAlign: "left" }}>
								<li>Created At: {createdAt || "Unknown"}</li>
								<li>Updated At: {updatedAt || "Unknown"}</li>
								<li>Setup Updated At: {setupUpdatedAt || "Unknown"}</li>
							</ul>
						</div>
					}
				>
					{daysCreatedAgo ? daysCreatedAgo + " ago" : "Unknown"}
				</Tooltip>
			</td>
			<td>
				<Link
					to={`/organisation/payroll`}
					className="btn btn-xs btn-primary"
					type="button"
					onClick={(e) => {
						switchCompany(client?.id, `/payroll`);
					}}
				>
					<Tooltip content="Switch Company">
						<BuildingOffice2Icon className="w-6 h-6 media-middle" />
					</Tooltip>
				</Link>
			</td>
		</tr>
	);
};

const mapStateToProps = (state) => {
	return {
		plansList: state?.payment?.bundles,
	};
};

const mapDispatchToProps = (dispatch) => ({
	switchCompany: (companyId, link) => dispatch(AUTHENTICATIONACTIONS.switchCompany(companyId, link)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientRow);
